<template>
    <div class="finance">
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="financeInfo"
            :currentPage="currentPage"
            @search-btn="handleSearch"
            @add-btn="handleAdd"
            @change-btn="change"
            @refresh-btn="handleRefresh"
            @preview-btn="handlePreview"
            @download-btn="handleDownload"
            @register-btn="handleRegister"
            @legal-register-btn="handleLegalRegister"
            @deleteData-btn="handleDelete"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
        </m-pane>
        <add-finance-dialog
            v-if="openAddFinanceDialog"
            :openAddFinanceDialog.sync="openAddFinanceDialog"
            :title="title"
            :row="row"
            :disabled="disabled"
            :supplierTab="supplierTab_"
            @updateTable="handleSearch">
        </add-finance-dialog>
        <attachmentDialog
            v-if='attachmentShow'
            :attachmentShow.sync='attachmentShow'
            :rowData='row'>
        </attachmentDialog>
        <midea-pay-dialog :supplierCode="supplierTab_.supplierCode" :visible="mideaPayVisible" @refresh="handleSearch" @close="mideaPayVisible = false" />
        <legal-midea-pay-dialog :supplierCode="supplierTab_.supplierCode" :visible="legalMideaPayVisible" @refresh="handleSearch" @close="legalMideaPayVisible = false" />
    </div>
</template>
<script>
import mPane from '../../../../../components/Table/Index.vue';
import config from './config.js';
import addFinanceDialog from './AddFinanceDialog.vue';
import attachmentDialog from '../../../../../components/AttachmentDialog';
import { getFinanceMsg, refreshBankAccount, deleteBankAccount } from '../../../../../api/finance.js';
import { dictWithUrl } from '@/components/lots/api';
import MideaPayDialog from '../../../manage/keyData/tabs/finance/MideaPayDialog.vue';
import LegalMideaPayDialog from '../../../manage/keyData/tabs/finance/LegalMideaPayDialog.vue';
import { PERSON } from '../../../../../constant/constant';
export default {
    name: 'Finance',
    components: { mPane, addFinanceDialog, attachmentDialog, MideaPayDialog, LegalMideaPayDialog },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierCode: '',
                    supplierName: '',
                    propertyNature: ''
                };
            }
        }
    },
    data() {
        return {
            totalData: [],
            config,
            pageTotal: 0,
            loading: false,
            currentPage: 1,
            row: {},
            title: '',
            openAddFinanceDialog: false,
            selected: [],
            showStausDialog: false,
            btnTitle: '',
            messageContent: '',
            attachmentShow: false,
            disabled: false,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            dict: {},
            supplierTab_: {},
            mideaPayVisible: false,
            legalMideaPayVisible: false
        };
    },
    methods: {
        /** 点击查询 调接口，拿table数据 **/
        handleSearch() {
            const params = {
                supplierCode: this.supplierTab_.supplierCode,
                ...this.searchParams
            };
            getFinanceMsg(params).then((res) => {
                if (res && res.code === '0') {
                    this.totalData = this.formatData(res.data.list);
                    this.pageTotal = res.data.totalCount;
                    this.totalData.forEach(function(item) {
                        if (item.accountFlag === 0) {
                            item.accountFlag = '新建';
                        } else if (item.accountFlag === 1) {
                            item.accountFlag = '启用';
                        } else if (item.accountFlag === 2) {
                            item.accountFlag = '停用';
                        }
                        if (item.factorageFlag === 0) {
                            item.factorageFlag = '否';
                        } else {
                            item.factorageFlag = '是';
                        }
                        if (item.mideaPayFlag) { // 美的付账号隐藏所有行操作
                            item.hiddenEvent = ['preview', 'download', 'change'];
                        }
                    });
                }
            });
        },
        /** 新增财务信息 **/
        handleAdd() {
            this.disabled = false;
            this.row = {
                supplierCode: '',
                bankAccount: '',
                bankAccountName: '',
                bankName: '',
                bankCode: '',
                ubankNo: '',
                bankAddress: '',
                accountCurrency: '',
                swiftCode: '',
                fileName: '',
                fileUrl: ''
            };
            this.title = '新增';
            this.openAddFinanceDialog = true;
        },
        /** 刷新 **/
        handleRefresh() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else {
                refreshBankAccount(this.selected[0].id).then(res => {
                    if (res && res.code === '0') {
                        this.handleSearch();
                        this.$message.success('刷新成功！');
                    }
                });
            }
        },
        /** 变更 **/
        change(data) {
            if (data.factorageFlag === '是') {
                this.$message.warning('保理账户，不允许变更!');
                return;
            }
            this.disabled = true;
            this.row = data;
            this.title = '变更';
            this.openAddFinanceDialog = true;
        },
        /** 预览 **/
        handlePreview(data) {
            this.row = data;
            if (!this.row.fileUrl) {
                this.$message.warning('请上传附件！');
            } else {
                this.row.downUrl = this.row.fileUrl;
                this.attachmentShow = true;
            }
        },
        /** 下载 **/
        handleDownload(data) {
            this.row = data;
            if (!data.fileUrl) {
                this.$message.warning('该银行账户无上传附件，无法下载');
            } else {
                window.location.href = data.fileUrl;
            }
        },
        rowDBclick(row) {},
        selectChange(data) {
            this.selected = [].concat(data);
        },
        pageChange(data) {
            this.searchParams.pageNo = data;
            this.handleSearch();
        },
        sizeChange(data) {
            this.$set(this.searchParams, 'pageSize', data);
            this.$set(this.searchParams, 'pageNo', 1);
            this.handleSearch();
        },
        closeStatusDialog() {
            this.showStausDialog = false;
        },
        formatData(data) {
            data.map(item => {
                item.accountType_ = this.dict.SYS_ACCOUNTS_TYPE[item.accountType];
                item.approvalStatus_ = this.dict.SRM_AUDIT_STATUS[item.approvalStatus];
            });
            return data;
        },
        handleRegister() {
            this.mideaPayVisible = true;
        },
        handleLegalRegister() {
            this.legalMideaPayVisible = true;
        },
        /** 删除 **/
        handleDelete() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据')
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！')
            } else {
                this.$confirm('是否确定删除选择的数据？', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    const idData = []
                    this.selected.forEach(item => idData.push(item.id))
                    deleteBankAccount(JSON.stringify(idData)).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('删除成功')
                            this.handleSearch()
                        }
                    })
                })
            }
        },
    },
    mounted() {
    },
    watch: {
        supplierTab: {
            handler(nVal) {
                if (Object.keys(nVal).length) {
                    const configTemp = JSON.parse(JSON.stringify(config));
                    // 非个体时去除'个人注册美的付'按钮，个体时去除'法人注册美的付'按钮
                    const hiddenEvent = nVal.propertyNature !== PERSON ? 'register' : 'legal-register'
                    const hiddenIndex = configTemp.buttonList.findIndex(item => item.event === hiddenEvent)
                    configTemp.buttonList.splice(hiddenIndex, 1)
                    this.config = configTemp;
                    this.supplierTab_ = JSON.parse(JSON.stringify(nVal));
                    dictWithUrl('SU_CURRENCY,SYS_ACCOUNTS_TYPE,SRM_AUDIT_STATUS').then(res => {
                        this.dict = res.data;
                        this.handleSearch();
                    });
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="less">
.finance {
    width: 100%;
    .btn-list {
        height: 28px;
        background: #FFFBF2;
        border: 1px solid #FFECE3;
        border-radius: 0.5px;
        display: flex;
        align-items: center;
        .btn {
            margin-left: 30px;
            font-size: 14px;
            color: #666666;
        }
        .icon {
            margin-right: 5px;
        }
    }
    .content-item {
        font-size: 16px;
        margin:10px 0 ;
    }
    .finance-table {
        margin-top: 10px;
    }
}
</style>
